module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl3-100.7f7e8c7a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl3-100.png
// module id = 3314
// module chunks = 11